<template>
    <div>
        <app-button type="primary" @click="showModal()">
            Edit Selected
        </app-button>
        <div class="modal fade edit-mode" id="platform-edit-mode" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Multiple Edit Mode</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <app-checkbox
                                    label="Change Status"
                                    name="change-status"
                                    v-model="changeStatus"
                                    id="change-status">
                                </app-checkbox>
                            </div>
                            <div class="col-12 col-md-6">
                                <app-select
                                    v-show="changeStatus"
                                    name="selected-status"
                                    id="selected-status"
                                    :use-search="false"
                                    :is-multiple="false"
                                    :options="statuses"
                                    v-model="status"
                                ></app-select>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12 col-md-12">
                                <app-checkbox
                                    label="Change Description"
                                    name="change-description"
                                    v-model="changeDescription"
                                    id="change-description">
                                </app-checkbox>
                            </div>
                            <div class="col-12 col-md-12 mt-3">
                                <app-textarea
                                    v-show="changeDescription"
                                    name="edit-mode-description"
                                    id="edit-mode-description"
                                    rows="3"
                                    v-model="description"
                                ></app-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <block-loader v-if="loading"></block-loader>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <app-button type="primary" :is-disabled="!saveButtonDisabled" @click="save">
                            Save changes
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import route from "ziggy-js";
import debounce from "../../../helpers/debounce";

export default {
    props: {
        fields: {
            type: Array,
            default: []
        },
        statuses: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            changeStatus: false,
            changeDescription: false,
            status: 1,
            description: '',
            loading: false
        }
    },
    methods: {
        save: debounce(function () {
            this.loading = true
            axios.post(route('metadata.platform-fields.change-fields'), {
                change_status: this.changeStatus,
                change_description: this.changeDescription,
                status: +this.status,
                description: this.description,
                fields: this.fields
            }).then(response => {
                this.loading = false
                $('#platform-edit-mode').modal('hide');
                this.$notifications.success('The data was received successfully');
                location.reload();
            }).catch(err => {
                console.error(err.message);
                this.loading = false
                this.$notifications.error('Error changing status');
            });
        }, 1000),
        showModal() {
            $('#platform-edit-mode').modal('show');
        }
    },
    computed: {
        saveButtonDisabled() {
            return this.changeStatus || this.changeDescription;
        }
    }
}
</script>

<style lang="scss">
.modal-footer {
    position: relative;

    .loader-wrapper {
        margin-left: 50px;

        .loader-container {
            position: absolute !important;
        }
    }
}
</style>
